import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, ArrowRight, Phone, Mail } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { site } from "@/config/site";

export default function Merci() {
  const { state } = useLocation();
  const isDevis = state?.kind !== "contact";
  return (
    <>
      <Seo title="Merci — votre demande a bien été envoyée | MINES DE PARIS" description="Confirmation d'envoi de votre demande à MINES DE PARIS." path="/merci" noindex />
      <section className="relative flex min-h-[100svh] items-center overflow-hidden bg-night pt-24 text-white grain" data-testid="merci-page">
        <div className="absolute inset-0 grid-lines" aria-hidden="true" />
        <div className="container-x relative py-20">
          <Reveal className="max-w-2xl">
            <CheckCircle2 className="h-14 w-14 text-gold" aria-hidden="true" />
            <p className="eyebrow mt-8">Demande envoyée</p>
            <h1 className="h-display mt-5" data-testid="merci-title">Merci{state?.societe ? `, ${state.societe}` : ""}.</h1>
            <p className="lede mt-6 !text-white/75">
              {isDevis ? "Votre demande de devis a bien été envoyée." : "Votre message a bien été envoyé."} Nous vous répondons sous {site.quoteDelay}.
              Un accusé de réception vous a été adressé par email.
            </p>
            <div className="mt-8 rounded-xl border border-white/10 bg-white/[0.04] p-6 text-sm text-white/75">
              <p className="font-semibold text-white">Prochaines étapes</p>
              <ol className="mt-3 list-decimal space-y-2 pl-5">
                <li>Analyse de votre demande et, si besoin, prise de contact pour préciser certains points.</li>
                <li>Sourcing et comparaison des offres.</li>
                <li>Envoi d'une proposition chiffrée personnalisée.</li>
              </ol>
            </div>
            <div className="mt-10 flex flex-wrap items-center gap-5">
              <Link to="/" className="btn-gold" data-testid="merci-home-btn">Retour à l'accueil <ArrowRight className="h-4 w-4" /></Link>
              <a href={site.phoneHref} className="inline-flex items-center gap-2 text-sm text-white/75 hover:text-gold"><Phone className="h-4 w-4 text-gold" />{site.phone}</a>
              <a href={site.emailHref} className="inline-flex items-center gap-2 text-sm text-white/75 hover:text-gold"><Mail className="h-4 w-4 text-gold" />{site.email}</a>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
